import styled from 'styled-components/macro';
import { COLORS } from 'styleguide';

const CloseButton = styled.button`
  position: absolute;
  top: 7px;
  right: 7px;
  width: 24px;
  height: 24px;
  display: flex;
  justify-content: center;
  padding: 0;
  border-style: none;
  background: none;
  color: ${COLORS.gray60};
  cursor: pointer;

  &:hover {
    color: #fff;
  }

  &:focus {
    outline-color: ${COLORS.primary};
  }
`;

export default CloseButton;
